import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { userManagement } from "../app/endpoints";

export const authApi = createApi({
  reducerPath: "authApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_USER_MANAGEMENT_BASE_URL,
  }),
  tagTypes: ["authApi"],
  endpoints: (builder) => ({
    loginUser: builder.mutation({
      query: (body:any) => {
        return {
          url: userManagement.loginController.login,
          method: "POST",
          body: body,
        };
      },
    }),
    loginSendOtp: builder.mutation({
      query: (body:any) => {
          return {
            url: userManagement.loginController.loginSendOtp,
            method: 'POST',
            body: body,
          };
        },
      }),
      loginverifyOtp: builder.mutation({
        query: (body:any) => {
          return {
            url: userManagement.loginController.loginVerifyOtp,
            method: 'POST',
            body: body,
          };
        },
      }),
    logoutUser: builder.mutation({
      query: () => userManagement.loginController.logout,
    }),
    merchentUser: builder.mutation({
      query: (body:any) => {
        return {
          url: userManagement.loginController.saveMerchant,
          method: "POST",
          body: body,
        };
      },
    }),
    ssoLoginUser: builder.mutation({
      query: (body:any) => {
        return {
          url: userManagement.loginController.ssoLogin,
          method: "POST",
          body: body,
        };
      },
    }),
    permissions: builder.query({
      query: (body:any) => {
        return {
          url: userManagement.permissionController.getPermissions,
          method: "GET",
          body: body,
        };
      },
    }),
    googleAuthDetails: builder.mutation({
      query: (body:any) => {
        return {
          url: userManagement.loginController.googleAuthDetails,
          method: "GET",
          headers: { Authorization: `Bearer ${body.token}` },
        };
      },
    }),
  }),
});


export const {
  useLoginSendOtpMutation,
  useLoginverifyOtpMutation,
  useLoginUserMutation,
  useLogoutUserMutation,
  useSsoLoginUserMutation,
  useGoogleAuthDetailsMutation,
} = authApi;
